<template>
    <div class="transition  duration-150 ease-in-out  w-10/12 md:w-2/5">
        <div class="w-full bg-white rounded shadow-2xl">
            <div class="relative bg-gray-200 rounded-t py-4 px-4 xl:px-8">
                <svg class="hidden md:block absolute -ml-5 -mb-10 left-0 bottom-0" width="30px" height="30px" viewBox="0 0 9 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Tooltips-" transform="translate(-874.000000, -1029.000000)" fill="#FFFFFF">
                            <g id="Group-3-Copy-16" transform="translate(850.000000, 975.000000)">
                                <g id="Group-2" transform="translate(24.000000, 0.000000)">
                                    <polygon id="Triangle" transform="translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) " points="4.5 57.5 12.5 66.5 -3.5 66.5"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <svg class="absolute top-0 -mt-5 block md:hidden" xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23" fill="none">
                    <path id="Polygon 2" d="M13 0L25.9904 22.5H0.00961876L13 0Z" fill="#e5e7eb"/>
                </svg>
                <p class="text-base text-gray-800 font-normal leading-normal tracking-normal">{{ props.filter.name }}</p>
            </div>
            <div class="w-full h-full px-4 xl:px-8 py-5">
                <div class="flex w-full flex-col items-start space-y-[20px]">
                    <div class="flex flex-row space-x-[20px] items-center">
                        <div class="flex flex-row space-x-[6px] items-center">
                            <input  @click="dateType = 'is'" :checked="dateType === 'is'" id="type_is" name="type" type="radio" value="is">
                            <label for="type_is">Is</label>
                        </div>
                        <div class="flex flex-row space-x-[6px] items-center">
                            <input  @click="dateType = 'between'" :checked="dateType === 'between'" id="type_between" name="type" type="radio" value="between">
                            <label for="type_between">Between</label>
                        </div>
                    </div>
                    <Datepicker class="w-full" v-if="dateType === 'is'" :format="format" v-model="value" :enableTimePicker="false" />
                    <Datepicker class="w-full" v-else v-model="value" range :enableTimePicker="false" />
                </div>
                <div class="inline-flex space-x-[20px] justify-center items-center mt-[40px]">
                    <button @click="handleCancel" class="inline-flex items-center px-8 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-black bg-face-haze">
                        Cancel
                    </button>
                    <button @click="handleSubmit" class="bg-indigo-500 shadow-md shadow-indigo-500/50 px-8 py-2 text-white font-bold text-xs rounded-md transition duration-150 ease-in-out">Apply</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


const props = defineProps({filter: Object})
const emit = defineEmits(['apply', 'cancel'])

const dateType = ref('is')
const value = ref(null)
const dateValue = computed(() => {
    if (dateType.value === 'is') {
        return formatDate(value.value);
    }
    if (dateType.value === 'between') {
        if (value.value.length === 2) {
            const d1 = value.value[0]
            const d2 = value.value[1]
            return `${formatDate(d1)} : ${formatDate(d2)}`;
        }
        return `${value.value}`;
    }
})

onMounted(() => {
    value.value = new Date()
})

watch(dateType, (next, prev) => {
    if (next !== prev) {
        if (next === 'between') {
            value.value = [new Date(), new Date()]
        }

        if (next === 'is') {
            value.value = new Date()
        }
    }
})

const formatDate = (date) => {
    if (typeof date === 'object') {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }
    return `${date}`
}

const handleSubmit = () => {
    emit('apply', Object.assign(props.filter, {value: dateValue.value, verb: dateType.value}))
}

const setType = (type) => {
    dateType.value = type
}

const handleUpdate = (status) => {
    value.value = status
}

const format = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

const handleCancel = () => {
    emit('cancel')
}

</script>
